<div #toggle class="ft-dropdown date-range">
    <span>{{ displayText() }}</span> <i class="ft-icn-caret-down"></i>
</div>
